module.exports = __webpack_public_path__ + "static/media/banner.df3e6965.png";